import addParticipant from './addParticipant';
import addChatMessageFromNotification from './addChatMessageFromNotification';
import ChatSignInState from '../store/schema/ChatSignInState';
import InstantMessagePayload from 'owa-service/lib/contract/InstantMessagePayload';
import onPresenceChanged from '../presenceManager/onPresenceChanged';
import onSignedOn from '../presenceManager/onSignedOn';
import removeParticipant from './removeParticipant';
import removeUnacceptedChat from './removeUnacceptedChat';
import setServiceAvailability from '../presenceManager/setServiceAvailability';
import updateUserActivity from './updateUserActivity';
import { initChatAndToastFromPayload } from './startChat';
import { changeSignInState, setIsRetrySignInAllowed } from '../actions/presenceActions';

export default function onUcmaNotification(notification: InstantMessagePayload) {
    if (notification.EventType == 'Reload') {
        setIsRetrySignInAllowed(true /*isAllowed*/);
        setServiceAvailability(false /*isAvailable*/);
    } else {
        switch (notification.PayloadType) {
            case 'NewChatMessageToast':
                initChatAndToastFromPayload(notification);
                break;

            case 'NewChatMessage':
                addChatMessageFromNotification(notification);
                break;

            case 'QueryUserPresenceChange':
            case 'UpdateUserPresence':
            case 'UserPresenceChange':
                onPresenceChanged(notification);
                break;

            case 'SignOn':
                onSignedOn(notification);
                break;

            case 'ServiceUnavailable':
                if (notification.ServiceError == 'ClientSignOut') {
                    changeSignInState(ChatSignInState.SignedOut);
                }

                setServiceAvailability(false /*isAvailable*/);
                break;

            case 'UserActivity':
                updateUserActivity(notification);
                break;

            case 'ParticipantJoined':
                addParticipant(notification);
                break;

            case 'ParticipantLeft':
                removeParticipant(notification);
                break;

            case 'EndChatSession':
                removeUnacceptedChat(notification);
                break;

            case 'None':
                break;
        }
    }
}
